var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-user-root",on:{"click":_vm.goToSelectUser}},[(_vm.currentUser)?_c('div',[_vm._v(_vm._s(_vm.currentUser.fullName))]):_c('div',[_vm._v(_vm._s(_vm.$t('notLoggedIn')))])])}
var staticRenderFns = []

export { render, staticRenderFns }